export function validateEmail(email) {
    let reg_exp = /\S+@\S+\.\S+/;
    return reg_exp.test(email);
}
